import { AbacoWebModule, RouterReadyEvent, VueRouter, ApplicationReadyEvent, MenuItem } from '@abaco/web-common/src/app';
import globals from "./globals";
import myRoutes from "./routes";
import NewAgreementsVuexModule from './state';
import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { createMenu } from './menu';
import NewAgreementsApi from './api/NewAgreementsApi';
import MovementApi from './api/MovementApi';
import FarmerRegistryModule, { MODULE_ID as FARM_MODULE_ID } from '@abaco/farm-registry/src/modules/farm-registry';
import SSOModule, { MODULE_ID as SSO_MODULE_ID } from '@abaco/sso-web-module/src/abaco-module';

export const MODULE_ID = "agreements_module";
const rootPath = "/sitiagri-rest-api/api_basic/v1";
const sitiInfoRestApiPath = "/sitiInfoRestApi/api_basic/v1";

export default class NewAgreements implements AbacoWebModule {

    public static MODULE_ID = MODULE_ID;
    private ssoModule!: SSOModule;

    private newAgrApi!: NewAgreementsApi;
    private mvApi!: MovementApi;
    private apiCreated = false;

    private router!: VueRouter;

    readonly id = MODULE_ID;
    readonly routes = myRoutes;
    readonly globalComponents = globals;
    readonly vuexModule = new NewAgreementsVuexModule();
    menu: MenuItem[] = [];

    dependsOn = {
        [FARM_MODULE_ID]: () => new FarmerRegistryModule(),
        // [GLOBAL_MODULE_ID]: () => new GlobalStateModule(),
        // [CropPlanModule.MODULE_ID]: () => new CropPlanModule(),
        // [PortalGlobalStateModule.MODULE_ID]: () => new PortalGlobalStateModule(),
    };


    onRouterReady(evt: RouterReadyEvent) {
        this.router = evt.router;
        this.menu = createMenu(this.router);
    }

    async onApplicationReady(evt: ApplicationReadyEvent) {
        const tempModule = evt.modules.find(m => m.id === SSO_MODULE_ID) as SSOModule;
        if (!tempModule) {
            throw new Error("SSO Moduel not found");
        }
        this.ssoModule = tempModule;
    }

    async beforeEnterAnyRoutes(http: HTTPClient){
        if(this.apiCreated){
            return;
        }
        this.apiCreated = true;
        const NewAgreementsApi = (await import("./api/NewAgreementsApi")).default;
        this.newAgrApi = new NewAgreementsApi(http, rootPath);

        const MovementApi = (await import("./api/MovementApi")).default;
        this.mvApi = new MovementApi(http, rootPath, sitiInfoRestApiPath);
    }

    public get newAgreementsApi(){
        return this.newAgrApi;
    }

    public get movementApi(){
        return this.mvApi;
    }

}
